<template>
  <div id="appNavbar">
    <ServerError v-if="ServerError" />
    <v-navigation-drawer v-model="sideNav" fixed temporary color="#202020">
      <v-layout wrap justify-center v-if="appType == 'Client'">
        <v-flex xs12 v-for="(item, i) in stylCategories" :key="i" text-center pa-2 pl-4 text-uppercase
          align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12>
              <span :style="$route.query.styl == item._id
                  ? {
                    'font-family': 'poppinsbold',
                  }
                  : {
                    'font-family': 'poppinsthin',
                  }
                " style="
                  font-size: 15px;
                  color: #ffffff;
                  letter-spacing: 3px;
                  cursor: pointer;
                " @click="changeStylRoute(item)">
                {{ item.name }}
              </span>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center v-if="appType == 'Seller'">
        <v-flex xs12 v-for="(item, i) in sellerNavItems" :key="i" text-center pa-2 pl-4 text-uppercase
          align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12>
              <router-link :to="item.route">
                <span :style="$route.path == item.route
                    ? {
                      'font-family': 'poppinsbold',
                    }
                    : {
                      'font-family': 'poppinsthin',
                    }
                  " style="
                    font-size: 15px;
                    color: #ffffff;
                    letter-spacing: 3px;
                    cursor: pointer;
                  ">
                  {{ item.name }}
                </span>
              </router-link>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 text-center pa-2 pl-4 text-uppercase align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12>
              <span @click="appLogout" style="
                  font-family: poppinsthin;
                  font-size: 15px;
                  color: #ffffff;
                  letter-spacing: 3px;
                  cursor: pointer;
                ">
                Logout
              </span>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="sideNav2" fixed temporary class="hidden-lg-and-up" color="white" left>
      <v-layout wrap justify-center>
        <v-flex xs12 v-for="(item, i) in categories" :key="i" text-center pa-2 pl-4 text-uppercase align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12>
              <span v-if="
                item.name == 'Men' ||
                item.name == 'Women' ||
                item.name == 'Kids' ||
                item.name == 'Offer' ||
                item.name == 'Onam Sale'
              " @click="changeRoute(item)">
                <span :style="mainCategory == item._id ||
                    $route.query.type == item.name
                    ? {
                      'font-family': 'poppinsbold',
                    }
                    : {
                      'font-family': 'poppinslight',
                    }
                  " style="font-size: 15px; color: #3EA56E; letter-spacing: 2px">
                  {{ item.name }}
                </span>
              </span>
              <router-link v-else :to="'/products?name=' + item.name + '&category=' + item._id">
                <span style="
                    font-family: poppinslight;
                    font-size: 15px;
                    color: #3EA56E;
                    letter-spacing: 2px;
                  ">{{ item.name }}
                </span>
              </router-link>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#3EA56E"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 v-for="(item, i) in navItems" :key="i" text-center pa-2 pl-4 text-uppercase align-self-center link>
          <router-link :to="item.route">
            <v-layout wrap justify-center>
              <v-flex xs12>
                <span style="
                    font-family: poppinslight;
                    font-size: 15px;
                    color: #3EA56E;
                    letter-spacing: 2px;
                  ">{{ item.name }}</span>
              </v-flex>
              <v-flex xs12 pt-2>
                <v-divider color="#3EA56E"></v-divider>
              </v-flex>
            </v-layout>
          </router-link>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex v-if="!appLogin" xs12 text-center pa-2 pl-4 text-uppercase align-self-center>
          <router-link to="/Login">
            <v-layout wrap justify-center>
              <v-flex xs12>
                <span style="
                    font-family: poppinslight;
                    font-size: 15px;
                    color: #3EA56E;
                    letter-spacing: 2px;
                  ">Login</span>
              </v-flex>
              <v-flex xs12 pt-2>
                <v-divider color="#3EA56E"></v-divider>
              </v-flex>
            </v-layout>
          </router-link>
        </v-flex>
        <v-flex v-if="appLogin" xs12 text-center pa-2 pl-4 text-uppercase align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12 @click="appLogout">
              <span style="
                  font-family: poppinslight;
                  font-size: 15px;
                  color: #3EA56E;
                  letter-spacing: 2px;
                ">Logout</span>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#3EA56E"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <v-app-bar app dark color="#ffffff" dense flat height="56px" class="hidden-lg-and-up">
      <v-app-bar-nav-icon v-if="appType == 'Client'" class="hidden-lg-and-up" @click.native="sideNav2 = !sideNav2">
        <v-icon color="#3EA56E">mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/">
          <v-img src="./../../assets/kl06logo.png" height="45px" contain></v-img>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Account / Wishlist / Cart icons on mobile -->
      <div v-if="appType == 'Client'" class="mobile-actions d-flex align-center justify-end pr-1">
        <!-- Account Menu -->
        <v-menu offset-y left>
          <template v-slot:activator="{ attrs, on }">
            <v-btn icon v-bind="attrs" v-on="on" class="mobile-icon-btn">
              <v-icon color="#555" size="22">mdi-account-circle-outline</v-icon>
            </v-btn>
          </template>
          <v-card tile flat max-width="240px">
            <v-layout wrap justify-start text-left px-4>
              <v-flex pt-4 xs12>
                <span style="font-family: poppinssemibold; font-size: 16px; color: #000">Welcome</span>
              </v-flex>
              <v-flex xs12>
                <span v-if="!appLogin" style="font-family: poppinsmedium; font-size: 13px; color: #1e1b1b">Sign up as customer</span>
                <router-link to="/Profile">
                  <span v-if="appLogin" style="font-family: poppinsmedium; font-size: 13px; color: #1e1b1b">
                    {{ appUser && appUser.firstname }} {{ appUser && appUser.lastname }}
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 pt-3>
                <v-btn v-if="!appLogin" color="#0000001f" outlined rounded small :ripple="false" @click="$router.push('/Login')">
                  <span style="font-family: poppinssemibold; font-size: 14px; color: #3EA56E">LOGIN/SIGNUP</span>
                </v-btn>
                <v-btn v-if="appLogin" color="#0000001f" outlined tile small :ripple="false" @click="appLogout">
                  <span style="font-family: poppinssemibold; font-size: 14px; color: #3EA56E">LOGOUT</span>
                </v-btn>
              </v-flex>
              <v-flex xs12 py-2>
                <router-link to="/orders?type=Active"><div class="mobile-menu-link">Orders</div></router-link>
                <router-link to="/Wishlist"><div class="mobile-menu-link">Wishlist</div></router-link>
                <router-link to="/Profile/SavedAddress"><div class="mobile-menu-link">Saved Address</div></router-link>
              </v-flex>
            </v-layout>
          </v-card>
        </v-menu>

        <!-- Wishlist -->
        <router-link to="/wishlist">
          <v-btn icon class="mobile-icon-btn">
            <v-badge color="#3EA56E" :content="appWishlist ? appWishlist : '0'" overlap small offset-y="10" offset-x="10">
              <v-icon color="#555" size="22">mdi-bookmark-outline</v-icon>
            </v-badge>
          </v-btn>
        </router-link>

        <!-- Cart -->
        <router-link to="/Cart">
          <v-btn icon class="mobile-icon-btn">
            <v-badge color="#3EA56E" :content="appCart ? appCart : '0'" overlap small offset-y="10" offset-x="10">
              <v-icon color="#555" size="22">mdi-cart-outline</v-icon>
            </v-badge>
          </v-btn>
        </router-link>
      </div>
      <!-- Seller notifications on mobile -->
      <div v-if="appType == 'Seller'" class="mobile-actions d-flex align-center justify-end pr-1">
        <router-link v-if="$route.name !== 'sellerStatus'" to="/Seller/Notification">
          <v-btn icon class="mobile-icon-btn">
            <v-badge color="#3EA56E" :content="notificationCount ? notificationCount : '0'" overlap small offset-y="10" offset-x="10">
              <v-icon color="#555" size="22">mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn>
        </router-link>
      </div>
    </v-app-bar>
    <v-app-bar color="#edf8f1" elevation="0" height="70px" class="hidden-md-and-down">
      <v-layout wrap justify-center>
        <!-- <v-flex xs2 align-self-center pr-lg-6 pr-xl-12> -->
        <v-flex xs2 sm2 md1 align-self-center pa-2>
          <router-link to="/">
            <v-img src="./../../assets/newlogo.png" height="55px" contain></v-img>
          </router-link>
        </v-flex>

        <v-flex xs7 sm6 md8 v-if="appType == 'Client'" class="d-flex align-center justify-start overflow-hidden px-4">
          <div 
            class="category-chip-wrapper w-100"
            ref="scrollContainer"
            @mousedown="handleMouseDown"
            @mousemove="handleMouseMove"
            @mouseup="handleMouseUp"
            @mouseleave="handleMouseLeave"
            @mouseenter="isPaused = true"
          >
            <div class="category-chip-container d-flex align-center" v-if="categories">
              <v-chip
                v-for="(item, i) in categories"
                :key="'cat1-' + i"
                class="category-chip mx-1 px-4"
                :class="{ 'active-chip': mainCatName == item.urlname }"
                :color="mainCatName == item.urlname ? '#3EA56E' : '#f1f5f9'"
                :text-color="mainCatName == item.urlname ? 'white' : '#475569'"
                label
                @click="changeRoute(item)"
              >
                <span class="chip-label text-uppercase">{{ item.name }}</span>
              </v-chip>
              <!-- Duplicate categories for seamless marquee loop -->
              <v-chip
                v-for="(item, i) in categories"
                :key="'cat2-' + i"
                class="category-chip mx-1 px-4"
                :class="{ 'active-chip': mainCatName == item.urlname }"
                :color="mainCatName == item.urlname ? '#3EA56E' : '#f1f5f9'"
                :text-color="mainCatName == item.urlname ? 'white' : '#475569'"
                label
                @click="changeRoute(item)"
              >
                <span class="chip-label text-uppercase">{{ item.name }}</span>
              </v-chip>
            </div>
          </div>
        </v-flex>
        <v-flex xs4 text-left align-self-center v-if="appType == 'Seller'">
          <v-layout wrap justify-center fill-height>
            <v-flex xs12 text-left align-self-end>
              <span style="font-family: poppinssemibold; font-size: 20px">
                <!-- {{ appUser.firstname }} -->
                <!-- {{ appUser.lastname }} -->
                {{ appUser.organization }}
              </span>
            </v-flex>
            <v-flex xs12 text-left align-self-start>
              <span style="font-family: poppinslight; font-size: 15px">
                {{ appUser.city }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-spacer></v-spacer>
        <!-- <v-flex xs2 lg2 xl1 align-self-center>
          <v-form @submit.prevent="appSearch">
            <v-text-field
              class="searchBox"
              v-model="searchKey"
              prepend-inner-icon="mdi-magnify"
              placeholder="Search for products"
              solo
              flat
              hide-details
              color="#FF0F0F"
            ></v-text-field>
          </v-form>
        </v-flex> -->
        <v-flex xs6 lg2 xl2 v-if="appType == 'Client'" align-self-center>
          <AccountMenu />
        </v-flex>
        <v-flex xs6 lg3 v-if="appType == 'Seller'" align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs3 align-self-center text-center>
              <router-link v-if="$route.name !== 'sellerStatus'" to="/Seller/Notification">
                <v-btn icon>
                  <v-badge color="#3EA56E" :content="notificationCount ? notificationCount : '0'" overlap small offset-y="10" offset-x="10">
                    <v-icon color="#555" size="24">mdi-bell-outline</v-icon>
                  </v-badge>
                </v-btn>
              </router-link>
            </v-flex>
            <v-flex xs3 align-self-center>
              <v-avatar>
                <v-img :src="mediaURL + appUser.image">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#3EA56E"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>
            </v-flex>
            <v-flex xs6 align-self-center>
              <v-layout wrap justify-center fill-height>
                <v-flex xs12 text-left align-self-end>
                  <span style="font-family: opensansbold; font-size: 15px">
                    {{ appUser.firstname }}
                    {{ appUser.lastname }}
                  </span>
                </v-flex>
                <v-flex xs12 text-left align-self-start>
                  <span @click="appLogout" style="
                      cursor: pointer;
                      font-family: opensanssemibold;
                      font-size: 13px;
                      color: #979696;
                    ">
                    Log Out
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
import AccountMenu from "./accountMenu";
import axios from "axios";
export default {
  components: {
    AccountMenu,
  },

  data() {
    return {
      appLoading: false,
      ServerError: false,
      sideNav: false,
      sideNav2: false,
      user: {},
      notificationCount: 0,
      navItems: [
        { name: "Wishlist", route: "/Wishlist", type: "link" },
        { name: "Cart", route: "/Cart", type: "link" },
        { name: "Profile", route: "/Profile", type: "link" },
      ],
      sellerNavItems: [
        { name: "ANALYTICS", route: "/Seller" },
        { name: "ADD A PRODUCT", route: "/Seller/AddProduct" },
        { name: "PRODUCT SOLD", route: "/Seller/SoldProducts" },
        { name: "PENDING ORDERS", route: "/Seller/PendingOrders" },
        { name: "OFFERS", route: "/Seller/Offers" },
        { name: "INVENTORY", route: "/Seller/Inventory" },
        { name: "PRODUCT LIST", route: "/Seller/ProductList" },
        { name: "PROFILE", route: "/Seller/Profile" },
      ],
      userName: null,
      profilePic: null,
      cartItems: 0,
      searchKey: null,
      mainCatName: null,
      isPaused: false,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      scrollAnimationFrame: null,
      dragStarted: false,
    };
  },
  beforeMount() {
    this.mainCatName = this.$route.params.MainCategory
    this.searchKey = this.$route.query.searchKey;
    this.$store.dispatch("getCategory");
    this.mainCategoryId = this.mainCat
    // this.$store.dispatch("getStylCategory");
  },
  watch: {
    categories: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.$nextTick(() => {
            if (!this.scrollAnimationFrame) {
              this.startAutoScroll();
            }
          });
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.startAutoScroll();
    });
    if (this.appType === 'Seller') {
      this.getNotificationCount();
      this.$root.$on('notification-deleted', () => {
        this.getNotificationCount();
      });
    }
  },
  beforeDestroy() {
    if (this.scrollAnimationFrame) {
      cancelAnimationFrame(this.scrollAnimationFrame);
    }
    this.$root.$off('notification-deleted');
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appType() {
      return this.$store.state.userType;
    },
    appCart() {
      return this.$store.state.cartItems || 0;
    },
    appWishlist() {
      return this.$store.state.wishlistItems || 0;
    },
    categories() {
      return this.$store.state.categories.data;
    },
    mainCat() {
      return this.$store.state.SelectedIDS.MainCatId;
    },
    stylCategories() {
      return this.$store.state.stylCategories;
    },
  },

  methods: {
    getNotificationCount() {
      axios({
        method: "POST",
        url: "/notifications/all/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.notificationCount = response.data.data.length;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    appLogout() {
      this.$store.commit("logoutUser", true);
      if (this.sideNav2 == true) {
        this.sideNav2 = false;
      }
    },
    changeRoute(item) {
      if (this.isDragging) return; // Prevent click when dragging
      this.$store.commit("updateMainCatId", item._id);
      this.$store.commit("updateCatId", "");
      this.$store.commit("updateSubCatId", "");

      localStorage.setItem("mainCategory", item._id);
      {
        this.$router.push({
          path: "/products/" + item.urlname,
        });
        this.mainCategoryId = this.mainCat
        this.mainCatName = this.$route.params.MainCategory
      }
    },
    startAutoScroll() {
      if (this.scrollAnimationFrame) return;
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const animate = () => {
        if (!this.isPaused && !this.isDragging) {
          container.scrollLeft += 0.8;
          if (container.scrollLeft >= container.scrollWidth / 2) {
            container.scrollLeft = 0;
          }
        }
        this.scrollAnimationFrame = requestAnimationFrame(animate);
      };
      this.scrollAnimationFrame = requestAnimationFrame(animate);
    },
    handleMouseDown(e) {
      this.isDragging = false;
      this.isPaused = true;
      const container = this.$refs.scrollContainer;
      this.dragStarted = true;
      this.startX = e.pageX - container.offsetLeft;
      this.scrollLeft = container.scrollLeft;
    },
    handleMouseMove(e) {
      if (!this.dragStarted) return;
      const container = this.$refs.scrollContainer;
      const x = e.pageX - container.offsetLeft;
      const walk = (x - this.startX);

      if (Math.abs(walk) > 5) {
        this.isDragging = true;
      }

      if (this.isDragging) {
        e.preventDefault();
        container.scrollLeft = this.scrollLeft - walk;

        // Loop handling during drag
        if (container.scrollLeft >= container.scrollWidth / 2) {
          this.scrollLeft -= container.scrollWidth / 2;
          this.startX = x;
        } else if (container.scrollLeft <= 0) {
          this.scrollLeft += container.scrollWidth / 2;
          this.startX = x;
        }
      }
    },
    handleMouseUp() {
      this.dragStarted = false;
      setTimeout(() => {
        this.isDragging = false;
        this.isPaused = false;
      }, 50);
    },
    handleMouseLeave() {
      this.dragStarted = false;
      this.isDragging = false;
      this.isPaused = false;
    },
    changeStylRoute(item) {
      this.$router.push({
        path: "/Products",
        query: {
          styl: this.$route.query.styl != item._id ? item._id : null,
          category: this.$route.query.category,
          subcategory: this.$route.query.subcategory,
          searchKey: this.$route.query.searchKey,
          type: this.$route.query.type,
        },
      });
    },
    appSearch() {
      if (this.appType == "Client") {
        if (this.$route.query.searchKey != this.searchKey) {
          this.$router.push({
            path: "/Products",
            query: {
              styl: this.$route.query.styl,
              category: this.$route.query.category,
              subcategory: this.$route.query.subcategory,
              searchKey: this.searchKey,
              type: this.$route.query.type,
            },
          });
        } else {
          return;
        }
      } else {
        if (this.$route.query.searchKey != this.searchKey) {
          this.$router.push({
            path: "/Seller/Inventory",
            query: {
              searchKey: this.searchKey,
            },
          });
        } else {
          return;
        }
      }
    },
  },
};
</script>

<style>
input::-webkit-input-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: poppinsregular !important;
}

input::-moz-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: poppinsregular !important;
}

.searchBox .v-input__control {
  min-height: 10px !important;
}

.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}

.category-chip-wrapper {
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  cursor: grab;
  user-select: none;
}

.category-chip-wrapper:active {
  cursor: grabbing;
}

.category-chip-wrapper::-webkit-scrollbar {
  display: none;
}

.category-chip-container {
  display: flex;
  white-space: nowrap;
  padding: 4px 0;
  width: max-content;
}

.category-chip {
  flex: 0 0 auto;
  height: 36px !important;
  font-family: "ibmsemibold", sans-serif;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease !important;
  border-radius: 8px !important;
}

.category-chip:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.active-chip {
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.3) !important;
}

.chip-label {
  font-size: 13px;
  font-weight: 600;
}

@media (max-width: 1264px) {
  .category-chip-container {
    justify-content: flex-start;
  }
  .category-chip {
    height: 32px !important;
    padding: 0 12px !important;
  }
  .chip-label {
    font-size: 11px;
  }
}

/* Mobile header action icons */
.mobile-actions {
  gap: 16px;
  justify-content: flex-end;
  flex: 0 0 auto !important;
}

.mobile-icon-btn {
  width: 36px !important;
  height: 36px !important;
}

.mobile-menu-link {
  font-family: poppinsregular, sans-serif;
  font-size: 13px;
  color: #717171;
  padding: 4px 0;
  cursor: pointer;
}

::v-deep .v-badge__badge {
  font-size: 8px !important;
  height: 14px !important;
  min-width: 14px !important;
  padding: 2px !important;
  line-height: 10px !important;
}
</style>
